'use client';

import { useEffect } from 'react';

interface RenderGoogleTagScriptCustomProps {
	id: string;
	domain: string;
}

const RenderGoogleTagScriptCustom = ({ id, domain }: RenderGoogleTagScriptCustomProps) => {
	useEffect(() => {
		if (window.location.hostname === domain) {
			const tagManagerScript = document.createElement('script');
			tagManagerScript.async = true;
			tagManagerScript.src = `https://www.googletagmanager.com/gtag/js?id=${id}`;
			document.head.appendChild(tagManagerScript);

			const windowLayerScript = document.createElement('script');
			windowLayerScript.innerHTML = `
				window.dataLayer = window.dataLayer || [];
				function gtag(){dataLayer.push(arguments);}
				gtag('js', new Date());

				gtag('config', ${id});
			`;
			document.head.appendChild(windowLayerScript);

			// Clean up when component unmounts
			return () => {
				document.head.removeChild(tagManagerScript);
				document.head.removeChild(windowLayerScript);
			};
		} else {
			return () => {};
		}
	}, []);

	return null;
};

export default RenderGoogleTagScriptCustom;
